import ActionTypes from '../constants/action-types';

export const setPost = payload => ({
    type: ActionTypes.SET_POST,
    payload
});

export const setPostThankyou = payload => ({
    type: ActionTypes.POST_THANK_YOU,
    payload
});